<template>
<div>
  <h1>即時結果</h1>
  <div class="results">
    <div class="results-tab">
      <p>LA 分析型:</p>
      <h1>{{ personality.LA }}</h1>
    </div>
    <div class="results-tab">
      <p>RA 推動型:</p>
      <h1>{{ personality.RA }}</h1>
    </div>    
    <div class="results-tab">
      <p>LB 隨和型:</p>
      <h1>{{ personality.LB }}</h1>
    </div>    
    <div class="results-tab">
      <p>RB 表達型:</p>
      <h1>{{ personality.RB }}</h1>
    </div>
  </div>
</div>
</template>

<style scoped>
.results {
  display: grid;
  grid-template-columns: auto auto;
  padding: 10px 5%;
}

.results-tab {
  padding: 1em;
  font-size: 2.5em;
}

.results-tab:nth-child(1) {
  background-color: lightgray;
}

.results-tab:nth-child(4) {
  background-color: lightgray;
}

</style>

<script>
import { db } from '../main';

export default {
  name: 'Results',
  data() {
    return {
      personality: {
        LA: 0,
        LB: 0,
        RA: 0,
        RB: 0
      }
    }
  },
  firestore() {
    return {
      personality: db.collection("realtime-results").doc("9ZJbaU1hzDo08wNcGBfc")
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Results.vue